import { render } from "./ThongTinThucTe.vue?vue&type=template&id=74c44d58"
import script from "./ThongTinThucTe.vue?vue&type=script&lang=js"
export * from "./ThongTinThucTe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__